import {Button, Card, Carousel, Col, ConfigProvider, Flex, Row, Space} from "antd";
import {useNavigate} from "react-router-dom";
import styles from "./annon_landing.module.css";
import {useEffect, useState} from "react";
import axios from "axios";
import {useApp} from "../../../context/AppDataContext";
import {EyeOutlined} from "@ant-design/icons";

export default function AnnonLanding() {
    const navigate = useNavigate();
    const {isLoading, setIsLoading, apiUrl} = useApp();

    function handleLogin() {
        navigate("/login");
    }

    function handleSignup() {
        navigate("/signup");
    }

    return (
        <div>
            <Space direction="vertical" style={{width: '100%'}}>
                <GettingStarted handleSignup={handleSignup}/>
                <ListingsCarousel isLoading={isLoading} setIsLoading={setIsLoading} apiUrl={apiUrl}
                                  handleLogin={handleLogin}/>
            </Space>
        </div>
    )
}


function GettingStarted({handleSignup}) {
    return (
        <div className={styles.container}>
            <div className={styles.background}>
                <img
                    className={styles.backgroundImage}
                    src="/resources/images/backgrounds/getting_started_background_2.png"
                    alt="Background"
                    draggable={false}
                />
            </div>
            <div className={styles.overlay}>
                <p className={styles.getting_started_title}>
                    Swap or give away your stuff, easily!
                </p>
                <p className={styles.getting_started_sub_title}>
                    Join a community focused on swapping and gifting high-quality items.
                </p>
                <Button onClick={handleSignup} className={styles.getting_started_button}>Get Started!</Button>
            </div>
        </div>
    )
}


function ListingsCarousel({isLoading, setIsLoading, apiUrl, handleLogin}) {
    const [data, setData] = useState();

    function getLandingTop10Listings() {
        // Set loading to true when request starts
        setIsLoading(true);
        const config = {
            "Content-Type": "application/json",
        };
        axios.get(`/landing/top_listings`, config)
            .then((res) => {
                if (res.status === 200) {
                    setData([...res.data]);
                }
            })
            .catch((err) => {
                console.log(err);
            }).finally((res) => {
            // Set isLoading to false after the request completes
            setIsLoading(false);
        });
    }

    useEffect(() => {
        getLandingTop10Listings();
    }, []);

    return (
        <div className={styles.top_listings_section}>
            <p className={styles.top_listings_title}>Top Listings</p>
            {isLoading ? (
                <div className={styles.loading_state}>Loading listings...</div>
            ) : data?.length > 0 ? (
                <Carousel className={styles.carousel} autoplay={{dotDuration: true}} autoplaySpeed={2_000}>
                    {data?.map((item, index) => (
                        <Listing key={index} listingObject={item} handleLogin={handleLogin}/>))}
                </Carousel>
            ) : (
                <p>No listings available</p>
            )}
        </div>
    )
}


const {Meta} = Card;

function Listing({listingObject, handleLogin}) {
    /***
     Listing Object
     id: string
     is_open: bool
     title: string
     description: string
     condition: string
     trade_type: string
     is_pinned: bool
     no_views: int
     listing_image: string (base64)
     ***/
    const cardTitle = `${listingObject.title} | ${listingObject.condition} | ${listingObject.trade_type}`;
    const listingImage = listingObject?.listing_image?.includes('base64,') ? listingObject.listing_image :
        `data:image/png;base64,${listingObject.listing_image}`;
    return (
        <Card
            onClick={handleLogin}
            className={styles.card}
            cover={
                <img
                    className={styles.card_image}
                    alt={cardTitle}
                    src={listingImage}
                />
            }
        >
            <Meta
                title={cardTitle}
                description={
                    <div className={styles.card_description}>
                        {listingObject.description}
                        <div>
                            Views: {listingObject.no_views} <EyeOutlined/>
                        </div>
                    </div>
                }
            />
        </Card>
    )
}

function About() {
    return (
        <></>
    )
}